import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrDimensionIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M23 14H1C0.45 14 0 14.45 0 15V21C0 21.55 0.45 22 1 22H23C23.55 22 24 21.55 24 21V15C24 14.45 23.55 14 23 14ZM22 20H2V16H5V17C5 17.55 5.45 18 6 18C6.55 18 7 17.55 7 17V16H11V17C11 17.55 11.45 18 12 18C12.55 18 13 17.55 13 17V16H17V17C17 17.55 17.45 18 18 18C18.55 18 19 17.55 19 17V16H22V20Z" fill={color}/>
    <path d="M1 11.64C1.55 11.64 2 11.19 2 10.64V3.35999C2 2.80999 1.55 2.35999 1 2.35999C0.45 2.35999 0 2.80999 0 3.35999V10.65C0 11.2 0.45 11.65 1 11.65V11.64Z" fill={color}/>
    <path d="M23 2.35999C22.45 2.35999 22 2.80999 22 3.35999V10.65C22 11.2 22.45 11.65 23 11.65C23.55 11.65 24 11.2 24 10.65V3.35999C24 2.80999 23.55 2.35999 23 2.35999Z" fill={color}/>
    <path d="M7.07001 11.49C7.26001 11.68 7.58001 11.54 7.58001 11.28V7.99999H16.41V11.28C16.41 11.55 16.73 11.68 16.92 11.49L20.7 7.70999C21.09 7.31999 21.09 6.68999 20.7 6.29999L16.92 2.51999C16.73 2.32999 16.41 2.45999 16.41 2.72999V6.00999H7.59001V2.72999C7.59001 2.45999 7.27001 2.32999 7.08001 2.51999L3.30001 6.29999C2.91001 6.68999 2.91001 7.31999 3.30001 7.70999L7.08001 11.49H7.07001Z" fill={color}/>
  </BaseIcon>
));

AttrDimensionIcon.displayName = 'AttrDimensionIcon';
